module.exports = firebase =>
// Copy and paste this into your JavaScript code to initialize the Firebase SDK.
// You will also need to load the Firebase SDK.
// See https://firebase.google.com/docs/web/setup for more details.

firebase.initializeApp({
  "apiKey": "AIzaSyBw0znJKxpOz2z56yO-gRiNuyTu_iXSusc",
  "databaseURL": "https://map-it-fsa.firebaseio.com",
  "storageBucket": "map-it-fsa.appspot.com",
  "authDomain": "map-it-fsa.firebaseapp.com",
  "messagingSenderId": "770393365469",
  "projectId": "map-it-fsa"
});




// WEBPACK FOOTER //
// ./fire/setup.js